var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H4.778C3.243 15 2 13.88 2 12.5C2 11.12 3.243 9.99998 4.778 9.99998H5M19 15H19.222C20.756 15 22 13.88 22 12.5C22 11.12 20.756 9.99998 19.222 9.99998H19M9 10.5H15M9 14.5H15M12.55 19.343L17.55 17.914C17.9678 17.7945 18.3353 17.5422 18.5969 17.1952C18.8585 16.8482 19 16.4255 19 15.991V9.00998C19 8.57544 18.8585 8.15272 18.5969 7.80576C18.3353 7.4588 17.9678 7.20648 17.55 7.08698L12.55 5.65798C12.1905 5.55517 11.8095 5.55517 11.45 5.65798L6.45 7.08698C6.03238 7.20643 5.665 7.4586 5.4034 7.80536C5.14179 8.15212 5.00019 8.57461 5 9.00898V15.991C4.99998 16.4255 5.14148 16.8482 5.40309 17.1952C5.66471 17.5422 6.03221 17.7945 6.45 17.914L11.45 19.343C11.8095 19.4458 12.1905 19.4458 12.55 19.343Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMask);
export default __webpack_public_path__ + "static/media/face-mask.d87c1c0940991c6dc72b0f1441637f49.svg";
export { ForwardRef as ReactComponent };